import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CommonService } from '@tw/services';
import { Tooltip } from 'primeng/tooltip';
import { filter } from 'rxjs/operators';
import { SidebarService } from './sidebar.service';

@Component({
  selector: 'tw-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [CommonModule, Tooltip],
})
export class SidebarComponent implements OnInit {
  private isOpen = true;
  public isDockableSidebarOpened = true;
  isSidebarOpen = true;

  public get opened(): boolean {
    return this.isOpen;
  }

  constructor(
    public commonService: CommonService,
    private router: Router,
    public sidebarService: SidebarService,
    private location: Location,
  ) {}

  ngOnInit(): void {
    // Match the menu item on load
    this.setActiveMenuFromUrl(this.router.url);

    // Listen for route changes
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.setActiveMenuFromUrl(event.urlAfterRedirects);
      });
  }

  private setActiveMenuFromUrl(currentUrl: string) {
    const menuItems = this.commonService.getActivatedMenuItems(
      this.sidebarService.menuItems(),
    );

    // Match URL with routerLink
    const matchedItem = menuItems.find((item) =>
      currentUrl.includes(item.routerLink),
    );

    if (matchedItem) {
      this.sidebarService.selectedMenu = matchedItem;
    }
  }

  onDockableSideBarCollapse() {
    this.sidebarService.selectedMenu.expanded = false;
    this.isDockableSidebarOpened = false;
  }

  openDockableSideBar(item: any, event?: MouseEvent) {
    if (item.routerLink && event && (event.ctrlKey || event.metaKey)) {
      // Ctrl/Cmd + click: open in new tab and keep current tab state unchanged
      const absolutePath = item.routerLink.startsWith('/')
        ? item.routerLink
        : '/' + item.routerLink;
      const url = this.router.serializeUrl(
        this.router.createUrlTree([absolutePath]),
      );
      const fullUrl = this.location.prepareExternalUrl(url);
      window.open(fullUrl, '_blank');
      return;
    }

    this.sidebarService.selectedMenu = item;

    if (item.command) {
      item.command();
      return;
    }

    this.sidebarService.menuItems().forEach((menuItem: any) => {
      if (menuItem !== item) {
        menuItem.expanded = false;
      }
    });

    if (item.items) {
      item.expanded = !item.expanded;
      this.isDockableSidebarOpened = item.expanded;
    } else {
      if (item.routerLink) {
        // Navigate in same tab
        this.router.navigate([item.routerLink], {
          state: { navId: 0 },
        });
      }
      item.expanded = false;
    }
  }
}
